var map = {
	"./acollect.png": 14159,
	"./adiscuss.png": 23562,
	"./advertising_close.png": 22492,
	"./atread.png": 69174,
	"./aupvote.png": 22845,
	"./collect.png": 59142,
	"./collects.png": 74587,
	"./complaint.png": 88343,
	"./discuss.png": 17762,
	"./exhibition.png": 35684,
	"./game.png": 47554,
	"./gf.png": 20408,
	"./gfs.png": 86446,
	"./guide_1.png": 64622,
	"./guide_2.png": 76371,
	"./image.png": 89824,
	"./like.png": 92889,
	"./link.png": 86602,
	"./logo.png": 34201,
	"./more.png": 47822,
	"./sc.png": 10241,
	"./share.png": 59658,
	"./skeleton.png": 18449,
	"./top.png": 45785,
	"./tread.png": 17516,
	"./treads.png": 85607,
	"./upvote.png": 33041,
	"./upvotes.png": 23883,
	"./video.png": 73636,
	"./welfare_figma/Ellipse2.png": 81993,
	"./welfare_figma/activity-status-active.png": 613,
	"./welfare_figma/activity-status-ended.png": 23337,
	"./welfare_figma/activity-status-nostart.png": 69758,
	"./welfare_figma/privilege-label.png": 16059,
	"./welfare_figma/section-arrow.png": 43621,
	"./welfare_figma/sel.png": 68941,
	"./welfare_figma/vip-badge.png": 77966,
	"./welfare_figma/z1.png": 46487,
	"./welfare_figma/z2.png": 80825,
	"./xhwdl.png": 83907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83018;